<template>
    <div>
        <div
            :id="canvasId"
            class="app-map google-map kgr-row"
            v-if="consent"
        >
        </div>
        <div v-else class="kgr-alert kgr-alert--info kgr-alert--noIcon kgr-centered kgr-centered--horizontally kgr-centered--vertically app-map">
            <div style="margin:20%">
                <div class="kgr-postfix kgr-postfix--center kgr-postfix--smallGutters">
                    <div class="kgr-postfix__fixed">
                        <kgr-icon
                            icon-class="info-circle"
                            :small="true"
                        />
                    </div>
                    <div
                        v-t="'mapsConsent.maps.title'"
                        class="kgr-postfix__fluid kgr-text--bold"
                    ></div>
                </div>
                <div class="kgr-centered kgr-centered--horizontally kgr-centered--vertically">
                    {{ $t('mapsConsent.maps.text1') }}<br /><br />
                    <a
                        v-t="'Kartenansicht anzeigen'"
                        class="kgr-button kgr-button--accent kgr-button--big"
                        @click="setConsent()"
                    >
                    </a><br />
                    <span v-html="$t('mapsConsent.maps.text2')"></span>
                </div>
            </div>
        </div>
        <a v-if="consent" class="kgr-button kgr-button--small" @click="removeConsent()">{{ $t('Externe Inhalte nicht mehr anzeigen') }}</a>
    </div>
</template>

<script>
import AddressMap from '../../js/map/AddressMap';
import KgrIcon from '../../components/common/icon/Icon';

export default {
    components: {
        'kgr-icon': KgrIcon,
    },
    props: {
        locations: {
            type: Object,
            required: true,
        },
        baseLocation: {
            type: Object,
            required: false,
            default: null,
        },
        currentPinId: {
            type: String,
            required: false,
            default: null,
        },
        zoom: {
            type: Number,
            required: false,
            default: 13,
        },
        consentKey: {
            type: String,
            required: false,
            default: 'googleMapsConsent',
        },
        apiKey: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            adressMapParents: null,
            consent: false,
            scriptIncluded: false,
            canvasId: `map_canvas_${Math.random().toString(10).substr(2)}`,
        };
    },
    watch: {
        currentPinId() {
            if (this.adressMapParents !== null && this.consent) {
                this.adressMapParents.showMarkerInfo(this.currentPinId);
            }
        },
    },
    mounted() {
        this.consent = localStorage.getItem(this.consentKey) === '1';
        if (this.consent) {
            this.showMap();
        }
    },
    methods: {
        setConsent() {
            localStorage.setItem(this.consentKey, 1);
            this.consent = true;
            this.showMap();
        },
        removeConsent() {
            localStorage.removeItem(this.consentKey);
            this.adressMapParents.destroy();
            this.consent = false;
            this.$emit('mapsDisabled');
        },

        showMap() {
            this.$nextTick(() => {
                const config = {
                    canvasId: this.canvasId,
                    debug: 0,
                    zoom: this.zoom,
                };

                if (!this.scriptIncluded) {
                    const scriptTag = document.createElement('script');
                    scriptTag.setAttribute('src', `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}`);
                    document.head.appendChild(scriptTag);

                    scriptTag.addEventListener('load', () => {
                        this.adressMapParents = new AddressMap(config, this.locations, this.baseLocation);
                        this.adressMapParents.render(true);
                        this.scriptIncluded = true;
                    });
                } else {
                    this.adressMapParents.render(true);
                }
                this.$emit('mapsEnabled');
            });
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss">
    .app-map.google-map a:focus {
    outline-width: 0; // issue on a:focus
}
</style>
